import {
  SelectOptionType,
  Tab,
  TabPanels,
  Tabs,
  TabsList,
} from '@octano/global-ui';
import { useCallback } from 'react';
import { useIsQueryEnabled } from '../hooks/useIsQueryEnabled';
import { useWarningsSummaryDataLoader } from '../loaders/StudentWarningsSummaryDataLoader';
import StudentWarningsSummarySecondaryFilters from './StudentWarningsSummarySecondaryFilters';
import StudentWarningsSummaryTable from './StudentWarningsSummaryTable';

type StudentWarningsSummaryTabsProps = {
  defaultTab?: SelectOptionType;
  tabs?: SelectOptionType[];
};

const StudentWarningsSummaryTabs = ({
  tabs = [],
  defaultTab,
}: StudentWarningsSummaryTabsProps) => {
  const { query, updateQuery } = useWarningsSummaryDataLoader();

  const isQueryEnabled = useIsQueryEnabled(query);

  const handleChangeTab = useCallback(
    (tab: string | number) => {
      updateQuery({ ...query, warningGroupType: tab as string, page: 1 });
    },
    [updateQuery, query],
  );

  return (
    <Tabs defaultTab={defaultTab?.value} onSelection={handleChangeTab}>
      <TabsList>
        {tabs.map((group) => (
          <Tab id={group.value} disabled={!isQueryEnabled} key={group.value}>
            {group.label}
          </Tab>
        ))}
      </TabsList>
      <TabPanels>
        <div className="w-100 d-flex flex-wrap justify-content-center">
          {!!isQueryEnabled && <StudentWarningsSummarySecondaryFilters />}
          <StudentWarningsSummaryTable />
        </div>
      </TabPanels>
    </Tabs>
  );
};

export default StudentWarningsSummaryTabs;
